// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6172":"2b29537b","7424":"2b29537b"}[chunkId] + ".chunk.css";
};